module.exports = __webpack_public_path__ + "static/media/organic.47246468.jpg";